
<template>

    <div :class=" tabClasses " @click=" toggleTab() " v-if=" !isShowTab() ">

        <h3 class="tab-price" >${{ totalTicketAmount.toFixed( 2 ) }}</h3>
        <h3>MY CART</h3>
        <h3 class="tab-count">{{ currentTab.length }}</h3>
    </div>

</template>

<script>

    import { mapGetters, mapActions } from 'vuex';

    export default {

        name: 'tab-bar',
        computed: {

            ...mapGetters({

                totalTicketAmount : 'orderTab/getCost',
                currentTab        : 'orderTab/currentTab',
                tabOpen           : 'orderTab/tabOpen',
                currentRoute      : 'currentRoute',
                currentLocation   : 'merchant/currentLocation',
                merchantIdCrocante  : 'merchantIdCrocante',
            }),
            tabClasses: function(){

                const base = [ 'tab-bar' ];
                base.push( ( this.currentLocation.merchantId == this.merchantIdCrocante ) ? 'tab-bar-crocante' :  'tab-bar-xo');
                base.push( ( this.tabOpen ) ? 'tab-bar-opened' : 'tab-bar-closed' );

                return base.join( ' ' );
            }
        },
        methods: {

            ...mapActions({

                toggleTab : 'orderTab/toggleTab'
            }),
            isShowTab(){
                return this.currentRoute.name == 'not-found' || this.currentRoute.name == 'merchant-location' || this.currentRoute.name == 'signin';
            }
        }
    }

</script>

<style scoped>

    .tab-bar {

        display: flex;
        justify-content: space-between;
        align-items: center;

        width: 100%;
        height: 55px;

        box-sizing: border-box;
        position: fixed;
        z-index: 250;
        padding: 0px 10px;
        left: 0;
        right: 0;

        transition: bottom 0.3s ease-in;
    }
    .tab-bar-opened {

        bottom: 65px;
    }
    .tab-bar-closed {

        bottom: 0px;
    }

    .tab-bar-xo {
        background-color: #e10b00;
        color: #fff;
    }

    .tab-bar-crocante {
        background-color: #DFEC72;
        color: #4A2612;
    }

    

    .tab-bar > h3 {

        margin: 0;
        padding: 0;
    }
    .tab-count {

        cursor: pointer;
        border: 2px solid #fff;
        width: 25px;
        text-align: center;
    }

</style>